__turbopack_context__.v({
  "blueIcon": "InlineListRow-module-scss-module__UTlZXW__blueIcon",
  "copy": "InlineListRow-module-scss-module__UTlZXW__copy",
  "cta": "InlineListRow-module-scss-module__UTlZXW__cta",
  "gridItem": "InlineListRow-module-scss-module__UTlZXW__gridItem",
  "gridRow": "InlineListRow-module-scss-module__UTlZXW__gridRow",
  "gridThreeItem": "InlineListRow-module-scss-module__UTlZXW__gridThreeItem",
  "headline": "InlineListRow-module-scss-module__UTlZXW__headline",
  "iconBox": "InlineListRow-module-scss-module__UTlZXW__iconBox",
  "iconWrapper": "InlineListRow-module-scss-module__UTlZXW__iconWrapper",
  "image": "InlineListRow-module-scss-module__UTlZXW__image",
  "imageContainer": "InlineListRow-module-scss-module__UTlZXW__imageContainer",
  "lockup": "InlineListRow-module-scss-module__UTlZXW__lockup",
});
